import { Link, Accordion, ListItemText, AccordionDetails, AccordionSummary, Box, Typography, List, ListItem, Table, TableContainer, Paper, TableHead, TableBody, TableRow, TableCell, Stack, useTheme, useMediaQuery, Card, CardContent } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import OtherReportsTable from './OtherReportsTable';

interface Props {
  lateContributionSummary: string;
  
}

const NonLegislativeCandidates = (props: Props): JSX.Element => {

  const candidateOffices = [
    {
      type: 'Statewide Offices',
      description: 'The Constitutional Offices: Governor, Lieutenant Governor, Attorney General, State Secretary, State Treasurer or State Auditor.'
    },
    {
      type: "The Governor's Council",
      description: 'One of the eight district seats of the Executive Council.'
    },
    {
      type: 'County and District Offices',
      description: 'County Clerks of Court, Commissioners, and Treasurers; Registers of Deeds and Probate; District Attorneys; Sheriffs and Suffolk County Clerks of the Superior and Supreme Judicial Courts'
    },
    {
      type: 'City Council Seats in Cities with Populations of 65,000 or More',
      description: 'This includes the communities of Boston, Brockton, Cambridge, Fall River, Framingham, Haverhill, Lawrence, Lowell, Lynn, Malden, New Bedford, Newton, Quincy, Somerville, Springfield, Waltham and Worcester.'
    },
    {
      type: 'Mayor',
      description: 'All candidates for mayor file campaign finance reports with OCPF.'
    }
 
  ];

  return (
    <Box>
      <Typography variant="h6" gutterBottom fontWeight={600}>
        Non-Legislative Candidates
      </Typography>
      <Typography variant="body1" component={'p'} gutterBottom>
        Non-Legislative and certain local candidates are required to register with OCPF (click <Link underline="none" href="https://www.ocpfreporter.us/OnlineOrganization/" target="_blank">here</Link> to register).
      </Typography>

      <Box marginTop={2} marginBottom={2}>
        <Accordion >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Stack direction='row' spacing={1}>
              <HelpOutlineIcon color="primary" />
              <Typography variant={'subtitle1'}>Which Non-Legislative candidates are required to register with OCPF?</Typography>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <List>
                {candidateOffices.map((office, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      primary={office.type}
                      secondary={office.description}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" marginBottom={1}><b>Report Filing Schedules</b></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <OtherReportsTable lateContributionSummary={props.lateContributionSummary} />
        </AccordionDetails>
      </Accordion>

    </Box>
  );
};

export default NonLegislativeCandidates;